(ns core.front.href
  (:require [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]
            [reitit.frontend.easy :as rfe]))

(defn branded-href
  "Returns a URL path including the branding part."
  [branding route-name & [path-params query-params]]
  #_{:clj-kondo/ignore [:discouraged-var]}
  (rfe/href route-name (assoc path-params :branding branding)
            query-params))

(defn href
  "Returns a URL path including the branding part. Should not be called from a non-reactive context."
  [name & [path-params query-params]]
  (branded-href (<sub [:branding/as-string])
                name
                path-params
                query-params))

(defn match->href
  "Returns the percent-encoded URL path for a route match."
  [match]
  (branded-href (-> match :path-params :branding)
                (-> match :data :name)
                (:path-params match)
                (-> match :parameters :query)))

(rf/reg-sub ::branded-href
  :<- [:branding/as-string]
  (fn [branding [_ route-name & [path-params query-params]]]
    (branded-href branding route-name path-params query-params)))
